import React, { FC } from 'react';
import { CrewTreeProps, CrewNodeProps } from './types';
import { CrewTreeContainerStyled, HrStyled, ArrowStyled, AvatarRegularStyled } from './styled';
import { AvatarSize, Separator, SeparatorType, Box, Text } from '@bechtel/gds';
import { startCase, toLower } from 'lodash';

const CrewNode: FC<CrewNodeProps> = ({ crewMember, gridRowLocation, showAffected, isLastNode }) => {
  const { isAffected, showArrow, avatarSize, hideTreeLine, title } = crewMember;
  return (
    <>
      <Box
        flexDirection={{ sm: 'column' }}
        justifyContent={{ sm: 'center' }}
        alignItems={{ sm: 'center' }}
        style={{ gridRow: gridRowLocation, gridColumn: 1, opacity: isAffected ? 0.5 : 1 }}
      >
        <AvatarRegularStyled
          style={{ marginBottom: '4px' }}
          size={avatarSize ? avatarSize : AvatarSize.LARGE}
          src={crewMember.imageUrl ? crewMember?.imageUrl : ''}
          hasImageUrl={crewMember && crewMember.imageUrl ? true : false}
        ></AvatarRegularStyled>
        <Text
          size="400"
          weight="600"
          color="grey.1000"
          family="graphikCompact"
          style={{ marginBottom: '4px', whiteSpace: 'nowrap' }}
        >
          {startCase(toLower(`${crewMember.firstName} ${crewMember.lastName}`))}
        </Text>
        <Text size="400" color="grey.600" family="graphikCompact" style={{ marginBottom: '4px', whiteSpace: 'nowrap' }}>
          {title}
        </Text>
      </Box>
      {!isLastNode && (
        <Box
          justifyContent={{ sm: 'center' }}
          alignItems={{ sm: 'center' }}
          py={{ sm: '300' }}
          style={{ gridRow: gridRowLocation + 1, gridColumn: 1 }}
        >
          <Separator
            size={!hideTreeLine ? '16px' : '12px'}
            borderWidth="1px"
            type={SeparatorType.VERTICAL}
            color={!hideTreeLine ? 'grey.300' : 'transparent'}
          />
        </Box>
      )}
      {showAffected && showArrow && (
        <Box
          style={{ gridRow: gridRowLocation, gridColumn: 2 }}
          justifyContent={{ sm: 'center' }}
          alignItems={{ sm: 'flex-start' }}
          flexGrow={{ sm: '1' }}
          mt={!hideTreeLine ? { sm: '500' } : { sm: '400' }}
        >
          <HrStyled />
          <ArrowStyled />
        </Box>
      )}
    </>
  );
};

export const CrewTree: FC<CrewTreeProps> = ({ crewMembers, showAffectedCrewMembers, label }) => {
  return (
    <CrewTreeContainerStyled nodeCount={crewMembers.length} showAffectedNode={showAffectedCrewMembers}>
      <Box flexGrow={{ sm: '1' }} justifyContent={{ sm: 'center' }} style={{ gridRow: 1, gridColumn: 1 }}>
        <Text size="500" family="graphik" weight="600" color="grey.1000" style={{ whiteSpace: 'nowrap' }}>
          {label}
        </Text>
      </Box>
      {crewMembers.map((crewMember, index) => {
        const gridRowLocation = index == 0 ? index + 2 : index * 2 + 2;
        return (
          <CrewNode
            key={index}
            crewMember={crewMember}
            gridRowLocation={gridRowLocation}
            isLastNode={index == crewMembers.length - 1}
            showAffected={showAffectedCrewMembers}
          ></CrewNode>
        );
      })}
    </CrewTreeContainerStyled>
  );
};
